import axios from 'axios';

const baseUrl = process.env.REACT_APP_SERVIDOR;
const REQUEST = {};

const defaultBody = () => {
    const servidor = JSON.parse(sessionStorage.getItem('projeto'))?.servidor || JSON.parse(sessionStorage.getItem('user'))?.servidor;
    const projeto = JSON.parse(sessionStorage.getItem('user'))?.cod_projeto || JSON.parse(sessionStorage.getItem('projeto'))?.projeto;
    const cd = JSON.parse(sessionStorage.getItem('user'))?.cod_cd || JSON.parse(sessionStorage.getItem('cd'))?.cod_cd;
    const usuario = JSON.parse(sessionStorage.getItem('user'))?.cod_usuario || JSON.parse(sessionStorage.getItem('projeto'))?.usuario;
    
    return { servidor, projeto, cd, usuario };
};
const defaultHeaders = () => {
    const token = sessionStorage.getItem('token');

    return { 'Authorization': 'Bearer ' + token };
};

const formatBody = (body={}) => (
    Object.keys(body).reduce((acc, key) => body[key] === '' && key !== 'busca' ? { ...acc, [key]: null } : { ...acc, [key]: body[key] }, {})
);

REQUEST.get = (url='', params={}, headers={}) => {
    params = Object.keys(params).reduce((acc, key) => {
        if ((params[key] === '' && key !== 'busca') || params[key] === null) return acc;
        return { ...acc, [key]: params[key] };
    }, {});
    const queryParams = new URLSearchParams({ ...defaultBody(), ...params }).toString();
    return axios.get(`${baseUrl}${url}?${queryParams}`, { headers: { ...headers, ...defaultHeaders() } });
};

REQUEST.post = (url='', body={}, headers={}) => {
    return axios.post(`${baseUrl}${url}`, { ...defaultBody(), ...formatBody(body) }, { headers: { ...headers, ...defaultHeaders() } });
};

REQUEST.patch = (url='', body={}, headers={}) => {
    return axios.patch(`${baseUrl}${url}`, { ...defaultBody(), ...formatBody(body) }, { headers: { ...headers, ...defaultHeaders() } });
};

REQUEST.put = (url='', body={}, headers={}) => {
    return axios.put(`${baseUrl}${url}`, { ...defaultBody(), ...formatBody(body) }, { headers: { ...headers, ...defaultHeaders() } });
};

REQUEST.delete = (url='', body={}, headers={}) => {
    return axios.delete(`${baseUrl}${url}`, { data: { ...defaultBody(), ...formatBody(body) }, headers: { ...headers, ...defaultHeaders() } });
};

export default REQUEST;
